<script setup>
import { onMounted, ref, watch } from 'vue';
import { useMarketsStore } from '@/stores/markets';
import { useDateTimeSportFiltersStore } from '@/stores/date_time_sport_filters';
import { usePreSportsStore } from '@/stores/pre_sports';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import { useLandingSportsStore } from '@/stores/landing_sports';

const marketsStore = useMarketsStore();
const preSportsStore = usePreSportsStore();
const datetimeSportFiltersStore = useDateTimeSportFiltersStore();
const direction = ref(document.dir);

console.log(direction.value)
const splideOptions = ref({
	direction: direction.value,
	pagination: false,
	// arrows: false,
	// focus: 'center',
	autoWidth: true,
	gap: 20,
	trimSpace: 'move'
});

onMounted(() => {
	if (preSportsStore.selected_pre_sport_id) {
		let overview_markets = marketsStore.sportOverviewMarkets(preSportsStore.selected_pre_sport_id);
		if (overview_markets?.length > 0) datetimeSportFiltersStore.selected_overview_market = overview_markets[0];
	}

	const el = document.querySelector('.overview-markets-container');

	window.addEventListener('scroll', () => {
		if (window.scrollY >= 80) {
			el.classList.add('is-stuck');
		} else {
			el.classList.remove('is-stuck');
		}
	});
})
const selectMarket = (overview_market) => {
	datetimeSportFiltersStore.selected_overview_market = overview_market;
}

watch(() => preSportsStore.selected_pre_sport_id, (newValue) => {
	if (newValue) {

		if (useLandingSportsStore().getSelectedOverviewMarket) {
			datetimeSportFiltersStore.selected_overview_market = useLandingSportsStore().getSelectedOverviewMarket;
			useLandingSportsStore().selected_overview_market = null;
			useLandingSportsStore().selected_sport = null;

			return;
		}

		let overview_markets = marketsStore.sportOverviewMarkets(newValue);
		if (overview_markets?.length > 0) datetimeSportFiltersStore.selected_overview_market = overview_markets[0];
	}
});


watch(() => marketsStore.overview_markets, (newValue) => {
	if (!newValue) return;
	if (preSportsStore.selected_pre_sport_id) {
		let overview_markets = marketsStore.sportOverviewMarkets(preSportsStore.selected_pre_sport_id);
		if (overview_markets?.length > 0) datetimeSportFiltersStore.selected_overview_market = overview_markets[0];
	}
});


</script>

<template>
	<div class="overview-markets-container">
		<Splide :options="splideOptions">
			<SplideSlide v-for="market in marketsStore.sportOverviewMarkets(preSportsStore.selectedPreSportId)" :key="market.id">
				<span class="market-name" :class="{ 'is-active': market.slug == datetimeSportFiltersStore.selected_overview_market?.slug }" @click="selectMarket(market)">{{ market.name }}</span>
			</SplideSlide>
		</Splide>
	</div>
</template>
<style scoped>
.overview-markets-container{
	margin: 12px;
	border-bottom: 1px solid var(--tab-gray);
	position: sticky;
    position: sticky;
    top: 100px;
    z-index: 10;
	transition: top 0.2s ease;
}

.overview-markets-container.is-stuck {
	background: var(--dark-gray);
	top: 50px;
    padding-top: 10px;
    height: 48px;
}
.market-name {
	color: var(--white);
	font-size: 12px;
	cursor: pointer;
	display: inline-block;
	position: relative;
	transition: color 0.3s ease;
	white-space: nowrap;
}

.market-name.is-active {
	color: var(--white);
	font-weight: 600;
}

.market-name.is-active::after {
	content: "";
	position: absolute;
	bottom: -2px;
	left: 0;
	width: 100%;
	height: 3px;
	background-color: var(--primary);
	border-radius: 2px 2px 0 0;
}

:deep(.splide__arrow:disabled) {
	display: none !important;
}

html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--prev) {
	rotate: 180deg;
	right: -10px;
	top: -15px;
	display: flex;
	left: unset;
}

html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--next) {
	rotate: 180deg;
	left: -10px;
	top: -15px;
	display: flex;
	right: unset;
}

@media screen and (min-width: 320px) and (max-width: 767px) {



	html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--next) {
		left: 0px;
	}

	html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--prev) {
		right: 0px
	}
}

@media screen and (min-width: 768px) and (max-width: 1280px) {
	html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--next) {
		left: 0px;
	}

	html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--prev) {
		right: 0px
	}
}


</style>